import React from 'react';

import { Portal } from '@frontend/components';

import { useCascaderState } from '../context';
import {
  InternalContainer,
  InternalPositioningContainer,
} from '../subcomponents';
import { CascaderControl } from './CascaderControl';
import { CascaderMenu } from './CascaderMenu';
import { CascaderSearch } from './CascaderSearch';

/**
 * The CascaderContainer is the root organizer of the entire Cascader. It handles portaling and positioning,
 * as well as deciding when to render in search mode or menu mode.
 */
export const CascaderContainer = () => {
  const { isOpen, isSearchMode } = useCascaderState();

  return (
    <InternalContainer>
      <CascaderControl />
      <Portal>
        {isOpen && (
          <InternalPositioningContainer>
            {isSearchMode ? <CascaderSearch /> : <CascaderMenu />}
          </InternalPositioningContainer>
        )}
      </Portal>
    </InternalContainer>
  );
};
